/**
 * 通用js方法封装处理 Copyright (c) 2019 ruoyi
 */

import Vue from 'vue'
import { getToken, getTenantId, getTimeOffset } from '@/utils/auth'

// 请求头部
export function lyHeaders() {
	let headers = {}
	headers['Lyods-Language'] = localStorage.getItem('language') || 'en_US'
	if (getToken()) {
		headers['Authorization'] = 'Lyods ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
	}
	if (getTenantId()) {
		headers['Lyods-TenantId'] = getTenantId() // 让每个请求携带自定义token 请根据实际情况自行修改
	}
	headers['Lyods-TimeOffset'] = getTimeOffset() // 取得當前時區new Date().getTimezoneOffset()
	return headers
}

// 日期格式化
export function lyParseTime(time, pattern) {
	if (arguments.length === 0 || !time) {
		return null
	}
	const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
	let date
	if (typeof time === 'object') {
		date = time
	} else {
		if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
			time = parseInt(time)
		} else if (typeof time === 'string') {
			time = time.replace(new RegExp(/-/gm), '/');
		}
		if ((typeof time === 'number') && (time.toString().length === 10)) {
			time = time * 1000
		}
		date = new Date(time)
	}
	const formatObj = {
		y: date.getFullYear(),
		m: date.getMonth() + 1,
		d: date.getDate(),
		h: date.getHours(),
		i: date.getMinutes(),
		s: date.getSeconds(),
		a: date.getDay()
	}
	const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
		let value = formatObj[key]
		// Note: getDay() returns 0 on Sunday
		if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
		if (result.length > 0 && value < 10) {
			value = '0' + value
		}
		return value || 0
	})
	return time_str
}

// 表单重置
export function lyResetForm(refName) {
	if (this.$refs[refName]) {
		this.$refs[refName].resetFields();
	}
}

// 重置表單FormErr對象值
export function lyResetFormErr(formErr) {
	if (formErr) {
		for (let fk in formErr) {
			formErr[fk] = "";
		}
	}
}

// 表单检验错误
export function lyFormError(formErr, globalErr, res, form) {
	if (res.GLOBAL && res.GLOBAL.length > 0) {
		let errmsg = "";
		for (var i = 0; i < res.GLOBAL.length; i++) {
			if (i > 0) {
				errmsg += ";";
			}
			errmsg += res.GLOBAL[i];
		}
		globalErr.msg = errmsg;
		globalErr.show = true;
	}
	if (res.FIELDERRS && res.FIELDERRS.length > 0) {
		for (var i in res.FIELDERRS) {
			formErr[res.FIELDERRS[i].field] =
				res.FIELDERRS[i].defaultMessage;
		}
	}
	if (form && res._token_uuid) {
		form._token_uuid = res._token_uuid;
	}
}

// 刪除函數封裝,callBack成功才回調
export function lyDelConfirm(_that, delForm, callBack) {
	this.$confirm(this.$t("PUB.confirmDelete"), this.$t("PUB.warn"), {
		confirmButtonText: this.$t("PUB.ok"),
		cancelButtonText: this.$t("PUB.cancel"),
		type: "warning"
	}).then(() => {
		delForm(_that.module, { id: _that.currId || _that.ids }).then(res => {
			if (res.code == 200) {
				// 成功回調
				if (callBack) {
					callBack();
				}
				this.lyMsgSuccess(_that, res, {}, 3);
			} else {
				if (res.GLOBAL && res.GLOBAL.length > 0) {
					let errmsg = "";
					for (var i = 0; i < res.GLOBAL.length; i++) {
						if (i > 0) {
							errmsg += ";";
						}
						errmsg += res.GLOBAL[i];
					}
					this.lyMsgError(errmsg);
				} else {
					this.lyMsgError(res);
				}
			}
		}).catch(err => {
			this.lyMsgError(err);
		});
	}).catch(() => {
		this.lyMsgInfo(this.$t("PUB.cancelOper"));
	});
}

// 列格式化處理
export function lyColumnConvert(hd, row, dicMap) {
	// 是否擴展
	if (row.extMap && lyStartsWith(hd.prop, "EXT_")) {
		let prop = hd.prop.substring(4);
		let extVal = row.extMap[prop];
		// 日期格式化
		if ("date" === hd.type || "datetime" === hd.type) {
			if (extVal) {
				return lySubstr(extVal, 19);
			}
			// 字典轉換
		} else if (hd.dic) {
			let dm = dicMap[hd.dic];
			// 字典支持,號分割
			if (dm && extVal) {
				let vals = extVal.split(/,|;/);
				let buf = "";
				for (let idx in vals) {
					if (idx > 0) {
						buf += ",";
					}
					let val = vals[idx];
					if (dm[val]) {
						buf += dm[val];
					} else {
						buf += val;
					}
				}
				return buf;
			}
		} else if ("amount" === hd.type) {
			return lyFormatNumber(extVal);
		}
		return extVal == null ? "" : extVal;
	} else {
		// 日期格式化
		if ("date" === hd.type || "datetime" === hd.type) {
			if (row[hd.prop]) {
				return lySubstr(row[hd.prop], 19)
			}
			// 字典轉換
		} else if (hd.dic) {
			let dm = dicMap[hd.dic];
			// 字典支持,號分割
			let propVal = row[hd.prop];
			if (propVal == null) {
				return "";
			}
			if (dm) {
				let vals = [propVal + ""];
				if (typeof propVal === "string") {
					vals = propVal.split(/,|;/);
				}
				let buf = "";
				for (let idx in vals) {
					if (idx > 0) {
						buf += ",";
					}
					let val = vals[idx];
					if (dm[val]) {
						buf += dm[val];
					} else {
						buf += val;
					}
				}
				return buf;
			}
		} else if ("amount" === hd.type) {
			return lyFormatNumber(row[hd.prop]);
		}
	}
	return row[hd.prop] == null ? "" : row[hd.prop];
}

export function lyStartsWith(val, str) {
	if (str == null || str == "" || val.length == 0
		|| str.length > val.length) {
		return false;
	}
	if (lySubstr(val, str.length) == str) {
		return true;
	}
	return false;
}

/**
 * 判斷對象是否為空
 * 
 * @param {判斷對象}
 *            obj
 */
export function lyEmptyObject(obj) {
	var isEmpty = true;
	for (let item in obj) {
		if (item) {
			isEmpty = false;
			break;
		}
	}
	return isEmpty;
}

/**
 * 将数值格式化成金额形式
 * 
 * @param num
 *            数值(Number或者String)
 * @param precision
 *            精度，默认不变
 * @param separator
 *            分隔符，默认为逗号
 * @return 金额格式的字符串,如'1,234,567'，默认返回原串
 * @type String
 */
export function lyFormatNumber(num, precision, separator) {
	var parts;
	// 判断是否为数字
	if (!isNaN(parseFloat(num)) && isFinite(num)) {
		// 把类似 .5, 5. 之类的数据转化成0.5, 5, 为数据精度处理做准, 至于为什么
		// 不在判断中直接写 if (!isNaN(num = parseFloat(num)) && isFinite(num))
		// 是因为parseFloat有一个奇怪的精度问题, 比如 parseFloat(12312312.1234567119)
		// 的值变成了 12312312.123456713
		num = Number(num);
		// 处理小数点位数
		num = (typeof precision !== 'undefined' ? (Math.round(num * Math.pow(10, precision)) / Math.pow(10, precision)).toFixed(precision) : num).toString();
		// 分离数字的小数部分和整数部分
		parts = num.split('.');
		// 整数部分加[separator]分隔, 借用一个著名的正则表达式
		parts[0] = parts[0].toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + (separator || ','));

		return parts.join('.');
	}
	return num;
}

/*******************************************************************************
 * Author : Yanfu Xie Url : http://www.yitu.org
 * 
 * Description : 正确截取单字节和双字节混和字符串 String str : 要截取的字符串 Number : 截取长度
 ******************************************************************************/
export function lySubstr(str, len) {
	if (!str || !len) {
		return '';
	}
	// 预期计数：中文2字节，英文1字节
	var a = 0;
	// 循环计数
	var i = 0;
	// 临时字串
	var temp = '';
	for (i = 0; i < str.length; i++) {
		if (str.charCodeAt(i) > 255) {
			// 按照预期计数增加2
			a += 2;
		} else {
			a++;
		}
		// 如果增加计数后长度大于限定长度，就直接返回临时字符串
		if (a > len) {
			return temp;
		}
		// 将当前内容加到临时字符串
		temp += str.charAt(i);
	}
	// 如果全部是单字节字符，就直接返回源字符串
	return str;
}

// 返回字符串特殊字符个数
export function lySpecialCharSize(str) {
	// 返回字符串特殊字符个数
	let size = 0;
	for (let i = 0; i < str.length; i++) {
		if (str.charCodeAt(i) < 48
			|| (str.charCodeAt(i) > 57 && str.charCodeAt(i) < 65)
			|| (str.charCodeAt(i) > 90 && str.charCodeAt(i) < 97)
			|| str.charCodeAt(i) > 122) {
			size++;
		}
	}
	return size;
}

// 判断字符串是否包含大小写
export function lyContainSensitive(str) {
	// 判断字符串是否包含大小写
	let big = false;
	let small = false;
	for (let i = 0; i < str.length; i++) {
		if (str.charCodeAt(i) >= 65 && str.charCodeAt(i) <= 90) {
			big = true;
		}
		if (str.charCodeAt(i) >= 97 && str.charCodeAt(i) <= 122) {
			small = true;
		}
		// 包含大小写直接返回 true
		if (big && small) {
			return true;
		}
	}
	return false;
}

// 返回字符串数字的个数
export function lyNumberSize(str) {
	// 返回字符串数字的个数
	let size = 0;
	for (let i = 0; i < str.length; i++) {
		if (str.charCodeAt(i) >= 48 && str.charCodeAt(i) <= 57) {
			size++;
		}
	}
	return size;
}

// 取得字符串字母的个数
export function lyAlphaCharSize(str) {
	// 取得字符串字母的个数
	let size = 0;
	for (let i = 0; i < str.length; i++) {
		if ((str.charCodeAt(i) >= 65 && str.charCodeAt(i) <= 90)
			|| (str.charCodeAt(i) >= 97 && str.charCodeAt(i) <= 122)) {
			size++;
		}
	}
	return size;
}

// 通用下载方法
export function lyDownload(rkey, type) {
	window.location.href = Vue.prototype.BASE_URL + "/common/" + rkey + "/" + type + "/download.do";
}

// Valid 驗證數據是不否為整數，同時支持例外
// 0 表示正數，1 表示負數，2 表示是同時支持正數和負數 3 表示小數,其他則默認為0
export function lyValidNumber(rule, ops, callback) {
	let value = ops;
	if (typeof ops === "object" && ops != null && ops.value != null) { 
		value = ops.value;
	}
	let nreg = /^\d+$/; // 正整數
	let rreg = /^\-[1-9][0-9]*$/; // 負整數
	let dreg = /(^([-]?)[1-9]([0-9]+)?(\.[0-9]{1,6})?$)|(^([-]?)(0){1}$)|(^([-]?)[0-9]\.[0-9]([0-9])?$)/; // 小數驗證
	let exps = this.exps; // 例外
	let isOk = false; // 正常標識
	// 如果是例外或值為空則直接返回
	if (!value || (exps && exps.indexOf(value) >= 0)) {
		isOk = true;
	} else {
		// 數據標識
		if ("2" === this.flag) {
			if (nreg.test(value) || rreg.test(value)) {
				isOk = true;
			}
		} else if ("1" === this.flag) {
			if (rreg.test(value)) {
				isOk = true;
			}
		} else if ("3" === this.flag) {
			if (dreg.test(value)) {
				isOk = true;
			}
		} else {
			if (nreg.test(value)) {
				isOk = true;
			}
		}
	}
	// 判斷是否驗證成功
	if (isOk) {
		callback();
	} else {
		callback(new Error(this.message));
	}
}

// Valid驗證是否郵箱
export function lyValidEmail(rule, ops, callback) {
	let value = ops;
	if (typeof ops === "object") {
		value = ops.value;
	}
	let reg = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
	if (value && !reg.test(value)) {
		callback(new Error(this.message));
	} else {
		callback();
	}
}

// Valid 去空格驗證必填
export function lyValidRequired(rule, ops, callback) {
	let value = ops;
	if (typeof ops === "object") {
		value = ops.value;
	}
	if (!value || value.trim() == "") {
		callback(new Error(this.message));
	} else {
		callback();
	}
}

// Valid驗證最小值
export function lyValidMin(rule, ops, callback) {
	let value = ops;
	if (typeof ops === "object") {
		value = ops.value;
	}
	if (value !== "" && parseInt(value) < this.min) {
		callback(new Error(this.message));
	} else {
		callback();
	}
}

// Valid驗證最大值
export function lyValidMax(rule, ops, callback) {
	let value = ops;
	if (typeof ops === "object") {
		value = ops.value;
	}
	if (value !== "" && parseInt(value) > this.max) {
		callback(new Error(this.message));
	} else {
		callback();
	}
}

// Valid 驗證範圍
export function lyValidRange(rule, ops, callback) {
	let value = ops;
	if (typeof ops === "object" && ops != null && ops.value != null) {
		value = ops.value;
	}
	if (value !== "" && (parseInt(value) > this.max || parseInt(value) < this.min)) {
		let msg = this.tmpl;
		msg = msg.replace("\{0\}", this.min).replace("\{1\}", this.max)
		callback(new Error(msg));
	} else {
		callback();
	}
}

// Valid 字符串验证数字字母下划线
export function lyValidString(rule, ops, callback) {
	let value = ops;
	if (typeof ops === "object") {
		value = ops.value;
	}
	let stringReg = /^(\w|-)+$/;
	if (value && !stringReg.test(value)) {
		callback(new Error(this.message));
	} else {
		callback();
	}
}

// 分割url参数返回集合
export function lyParseSearchParams(search) {
	let pm = {};
	if (search) {
		search = search.replace("?", "");
		let sps = search.split("&");
		for (let idx in sps) {
			let sd = sps[idx].split("=");
			if (sd.length >= 2) {
				pm[sd[0]] = sd[1];
			}
		}
	}
	return pm;
}

// 運算出主題色
export function lyGetThemeCluster(theme) {
	let tintColor = (color, tint) => {
		let red = parseInt(color.slice(0, 2), 16);
		let green = parseInt(color.slice(2, 4), 16);
		let blue = parseInt(color.slice(4, 6), 16);

		if (tint === 0) {
			// when primary color is in its rgb space
			return [red, green, blue].join(",");
		} else {
			red += Math.round(tint * (255 - red));
			green += Math.round(tint * (255 - green));
			blue += Math.round(tint * (255 - blue));

			red = red.toString(16);
			green = green.toString(16);
			blue = blue.toString(16);

			return `#${red}${green}${blue}`;
		}
	};

	let shadeColor = (color, shade) => {
		let red = parseInt(color.slice(0, 2), 16);
		let green = parseInt(color.slice(2, 4), 16);
		let blue = parseInt(color.slice(4, 6), 16);

		red = Math.round((1 - shade) * red);
		green = Math.round((1 - shade) * green);
		blue = Math.round((1 - shade) * blue);

		red = red.toString(16);
		green = green.toString(16);
		blue = blue.toString(16);

		return `#${red}${green}${blue}`;
	};

	let clusters = [theme];
	for (let i = 0; i <= 9; i++) {
		clusters.push(tintColor(theme, Number((i / 10).toFixed(2))));
	}
	clusters.push(shadeColor(theme, 0.1));
	return clusters;
}

// 變量主題信息
export function lyChangeTheme(theme, styleText) {
	let id = "chalk-style"; // 主題id
	let ORIGINAL_THEME = "#409EFF"; // default color
	// 當前主題
	let newCluster = lyGetThemeCluster(theme.replace("#", ""));
	// 上一主題色
	const oldCluster = lyGetThemeCluster(ORIGINAL_THEME.replace("#", ""));
	// 添加主題Style節點
	let styleTag = document.getElementById(id);
	if (!styleTag) {
		styleTag = document.createElement("style");
		styleTag.setAttribute("id", id);
		document.head.appendChild(styleTag);
	}

	// 動態變更主題內容
	let newStyle = styleText;
	oldCluster.forEach((color, index) => {
		newStyle = newStyle.replace(new RegExp(color, "ig"), newCluster[index]);
	});

	// 頁面變更
	styleTag.innerText = newStyle;

	// 動態變更其他
	/*
	 * const styles = [].slice .call(document.querySelectorAll("style"))
	 * .filter((style) => { const text = style.innerText; return ( new
	 * RegExp(oldVal, "i").test(text) && !/Chalk Variables/.test(text) ); });
	 * styles.forEach((style) => { let { innerText } = style; if (typeof
	 * innerText !== "string") return; // 主題變更 oldCluster.forEach((color, index) => {
	 * innerText = innerText.replace(new RegExp(color, "ig"),
	 * newCluster[index]); }); style.innerText = innerText; });
	 */
}

// 讀取圖稿文件內容
export function lyImgToBase64(imgUrl, setData, imgType) {
	// 一定要设置为let，不然图片不显示
	let image = new Image();
	// 解决跨域问题
	image.setAttribute("crossOrigin", "anonymous");
	let imageUrl = imgUrl;
	image.src = imageUrl;
	// image.onload为异步加载
	image.onload = () => {
		var canvas = document.createElement("canvas");
		canvas.width = image.width;
		canvas.height = image.height;
		var context = canvas.getContext("2d");
		context.drawImage(image, 0, 0, image.width, image.height);
		var quality = 0.8;
		// 这里的dataurl就是base64类型
		// 使用toDataUrl将图片转换成jpeg的格式,不要把图片压缩成png，因为压缩成png后base64的字符串可能比不转换前的长！
		let dataurl = canvas.toDataURL(imgType || "image/png", quality);
		// 貶值內容
		setData(dataurl);
	};
}

// 變更表格寬度
export function lyChgHeaderWidth(_that, prop, newWidth) {
	_that.views[_that.currViewId].chg = true;
	let theaders = _that.ltcMap[_that.currViewId];
	for (var i in theaders) {
		if (theaders[i].prop === prop) {
			theaders[i].width = newWidth;
		}
	}
}

// 封裝表格導出視圖
export function lyExpTableView(_that) {
	let theaders = _that.ltcMap[_that.currViewId];
	let cols = [];
	for (var i in theaders) {
		cols.push({
			name: theaders[i].prop,
			width: theaders[i].width,
		});
	}
	let schMap = _that.lsMap[_that.currViewId] || {};
	return {
		viewId: _that.currViewId,
		columns: cols,
		schMap: schMap,
		viewName: _that.views[_that.currViewId].name,
	};
}

// 转换为16进制
export function lyConvertRGB2Hex(_color) {
	const reg = /[0-9]\d+/g;
	const getArr = _color.match(reg);
	let hexStr = '#' + ((getArr[0] << 16) | (getArr[1] << 8) | getArr[2]).toString(16);
	return hexStr;
}

// 自定义穿梭框文本
export function lyTransferFunc(h, option) {
	if (option.description == "") {
		return <span title={option.name}>
			{option.name}
		</span>;
	}
	return <span title={option.name + '-' + option.description}>
		{option.name}-{option.description}
	</span>;
}

// 消息提示
// msg: 提示信息
// type: success 成功，warning 警告，error 错误
export function lyMessage(msg, type) {
	this.$message({
		message: msg,
		type: type
	});
}

// 金额校验
export function lyValidAmountRequired(rule, ops, callback) {
	if (ops <= 0) { // 必须大于0
		callback(new Error(this.message));
	} else {
		callback();
	}
}

// Map转List
export function lyMapToList(map) {
	const list = [];
	for (const item in map) {
		list.push({
			value: item,
			label: map[item],
		});
	}
	return list;
}

// 颜色转RGB
export function lyColorToRgb(color, opacity) {
	var str = "0x" + color.substring(1, color.length);
	var r = str & 0x0000ff;
	var g = (str & 0x00ff00) >> 8;
	var b = (str & 0xff0000) >> 16;
	return "rgba(" + b + "," + g + "," + r + "," + opacity + ")";
}

// 页面公用样式
// 图标LOGO和LOGO背景图
export function lyBackgroundStyleLogo(backgroundImg, theme) {
	let style = {
		"background-image": `url(${backgroundImg})`,
		"background-color": theme,
	};
	return style;
}
// 三角LOGO
export function lyTriangleLogo(theme) {
	let style = {
		"border-color":
			theme + " " + theme + " transparent transparent",
	};
	return style;
}
// 表单样式
export function lyFormStyle(theme, opacity) {
	let style = {
		background: lyColorToRgb(theme, opacity),
	};
	return style;
}

// 文件大小转换,初始默认bytes
export function lyChangeFileSize(file) {
	if (file == null || file == '') {
		return
	} else {
		file = Number(file);
	}
	// KB
	if (file >= 1024) {
		file = parseFloat(file / 1024).toFixed(2);
	} else {
		return file + " bytes";
	}
	// MB
	if (file >= 1024) {
		file = parseFloat(file / 1024).toFixed(2);
	} else {
		return file + " KB";
	}
	// GB
	if (file >= 1024) {
		file = parseFloat(file / 1024).toFixed(2);
	} else {
		return file + " MB";
	}
	return file + " G";
}

// 根据透明度变换颜色
export function lyThemeColor(theme, opacity) {
	// 16进制颜色值的正则
	var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
	// 把颜色值变成小写
	var color = theme.toLowerCase();
	if (reg.test(color)) {
		// 如果只有三位的值，需变成六位，如：#fff => #ffffff
		if (color.length === 4) {
			var colorNew = "#";
			for (var i = 1; i < 4; i += 1) {
				colorNew += color.slice(i, i + 1).concat(color.slice(i, i + 1));
			}
			color = colorNew;
		}
		// 处理六位的颜色值，转为RGB
		var colorChange = [];
		for (var i = 1; i < 7; i += 2) {
			colorChange.push(parseInt("0x" + color.slice(i, i + 2)));
		}
		return "RGB(" + colorChange.join(",") + "," + opacity + ")";
	} else {
		return color;
	}
}


// WEBPACK FOOTER //
// ./src/utils/lyods.js